import React, {useCallback, useEffect} from 'react';
import dynamic from 'next/dynamic';

import styles from '@styles/common/ageVerify.module.scss';
import {getAge} from '@utils/functions';

const DatePicker = dynamic(() => import('@components/common/datePicker'));
const MessageComponent = dynamic(() =>
	import('@components/common/MessageComponent'),
);

const AgeVerify = props => {
	const {
		items,
		callBack,
		state,
		isAuction = false,
		is18Active = false,
		isFormSubmitted = false,
		isBuyBefore = false,
	} = props;

	const checkAlcoholicProduct = useCallback(() => {
		let checkAlcoholic = null;
		if (isAuction) {
			if (isBuyBefore) {
				checkAlcoholic = items.Retailer_data?.storeDetail?.isChecked;
			} else {
				checkAlcoholic = items.retailer?.storeDetail?.isChecked;
			}
		} else {
			checkAlcoholic = items.find(
				item => item.product_data?.retailer?.storeDetail?.isChecked === true,
			);
		}
		callBack({is18Plus: checkAlcoholic ? true : false});
	}, [callBack, isAuction, isBuyBefore, items]);

	useEffect(() => {
		if (!is18Active) checkAlcoholicProduct();
	}, [checkAlcoholicProduct, is18Active]);

	const ageValidator = date => {
		callBack({currentDate: date});
	};

	const identityProof = useCallback(
		event => {
			callBack({willingToProvideIdentityProof: event.target.checked});
		},
		[callBack],
	);

	const checkAgeValidater = date => {
		const currentDate = date.split('/');
		const born = new Date(currentDate[2], currentDate[1] - 1, currentDate[0]);
		const age = getAge(born);
		let checkedAge = false;
		if (age >= 18) {
			checkedAge = true;
		} else {
			checkedAge = false;
		}
		return checkedAge;
	};

	if (!is18Active && !state.is18Plus) return null;

	return (
		<>
			<div className={styles.ageVerifyBody}>
				{is18Active ? (
					<p className={styles.guestText}>
						{
							'You must be over the age of 18 to purchase alcohol products. Please confirm your date of birth.'
						}
					</p>
				) : (
					<p className={styles.text}>
						{
							'You must be over the age of 18 to purchase alcohol products. Please confirm your date of birth.'
						}
					</p>
				)}

				<React.Fragment>
					<DatePicker
						showIcon={false}
						onChange={ageValidator}
						placeholder='Date of Birth'
					/>
				</React.Fragment>

				{is18Active && isFormSubmitted && !state.currentDate && (
					<div className={styles.centerAlign}>
						<MessageComponent
							message={'Date of Birth is required'}
							messageKey={'errorText'}
						/>
					</div>
				)}

				<div className={'row p-3'}>
					<input
						className=''
						type='checkbox'
						onChange={identityProof}
						id='flexCheckDefault'
					/>
					<label className='form-check-label col' htmlFor='flexCheckDefault'>
						<span className='text-danger'>*</span> I am able and willing to
						provide proof of identity and age upon delivery of the alcohol
						products in my order.
					</label>
				</div>

				{!!state.isIdentityError && (
					<div className={styles.centerAlign}>
						<MessageComponent
							message={'You must agree to this for your order to be processed.'}
							messageKey={'errorTextZero'}
						/>
					</div>
				)}

				{is18Active &&
					isFormSubmitted &&
					state.currentDate &&
					!checkAgeValidater(state.currentDate) && (
						<div className={styles.centerAlign}>
							<MessageComponent
								message={
									"Sorry, it's against the law to sell alcohol products to people under 18 years of age."
								}
								messageKey={'errorText'}
							/>
						</div>
					)}
			</div>
		</>
	);
};

export default AgeVerify;
